/**
 * Resolve the "now" clock used by `<RouteVariantRow>` to compute the
 * arrival HH:mm chip.
 *
 * In production this is just `() => new Date()` — the row reads the
 * real wall clock. Visual regression tests need a frozen clock so the
 * rendered HH:mm is byte-identical between runs; they install
 * `window.__metroTestClock = () => new Date('2026-05-16T12:00:00Z')`
 * (or similar) via `page.addInitScript` before navigation and the
 * routing surfaces (`MobileRouteCardOverlay`,
 * `StationCardOrDetailsRouter`) read it through this helper, and so does
 * the station page's "Open today" row (`StationOverview`), whose day class
 * would otherwise flip the baselines between weekdays and weekends.
 *
 * The seam is window-scoped (not a React context / not a prop) on
 * purpose: tests own the page-level initialisation and the routing
 * surfaces consume the clock at render time without a prop drill
 * through `RouteCard → RouteResultsList → RouteVariantRow`. The
 * function is a no-op `~30 bytes` minified — shipped in production
 * builds to keep the helper trivially reusable without a build-flag
 * gate (mirrors the `__mapDebug` pattern in `MetroMapCanvas`).
 */
export function resolveRouteCardClock(): (() => Date) | undefined {
  if (typeof window === 'undefined') return undefined
  const seam = (window as unknown as { __metroTestClock?: () => Date }).__metroTestClock
  return typeof seam === 'function' ? seam : undefined
}
